import { useDownloadAccounting } from "@entities/accounting/lib/hooks/useDownloadAccounting";
import { ToastService } from "@shared/lib/services";
import { Button, DatePicker, Typography } from "@shared/ui";
import dayjs, { Dayjs } from "dayjs";
import { useEffect, useState } from "react";
import styles from "./styles.module.scss";

const { RangePicker } = DatePicker;
const { Text } = Typography;

interface DownloadBillingProps {
  onClose: () => void;
}

type DateRange = [Dayjs | null, Dayjs | null] | null;

export function DownloadBilling({ onClose }: DownloadBillingProps) {
  const {
    downloadAccounting,
    isDownloadingAccountingLoading,
    isDownloadingAccountingSuccess,
  } = useDownloadAccounting();

  const [dateRange, setDateRange] = useState<DateRange>([
    dayjs().startOf("month"),
    dayjs().endOf("month"),
  ]);

  useEffect(() => {
    if (isDownloadingAccountingSuccess) {
      ToastService.success("Billing download started successfully");
      onClose();
      setDateRange(null);
    }
  }, [isDownloadingAccountingSuccess]);

  const handleSubmit = () => {
    const [from, to] = dateRange ?? [null, null];
    if (!from || !to) {
      ToastService.error("Please select a date range");
      return;
    }

    downloadAccounting({
      accountingDate: {
        from: from.startOf("day").toISOString(),
        to: to.endOf("day").toISOString(),
      },
    });
  };

  return (
    <div className={styles.container}>
      <div className={styles.field}>
        <Text strong>Select Date Range</Text>
        <RangePicker
          value={dateRange}
          onChange={(value) => setDateRange(value as DateRange)}
          format="DD MMM YYYY"
          allowClear
          disabled={isDownloadingAccountingLoading}
          className={styles.rangePicker}
        />
      </div>

      <div className={styles.actions}>
        <Button onClick={onClose} disabled={isDownloadingAccountingLoading}>
          Cancel
        </Button>
        <Button
          type="primary"
          onClick={handleSubmit}
          loading={isDownloadingAccountingLoading}
          disabled={!dateRange?.[0] || !dateRange?.[1]}
        >
          Submit
        </Button>
      </div>
    </div>
  );
}
